module.exports = __webpack_public_path__ + "img/start_3.e6822811.svg";